import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import logo from "../../../assets/img/mainn.png";
import { API_BASE_URL } from "../../../config/config";
import "./style.css";

function QuotePrezident() {
  const [texts, setTexts] = useState([]);
  const { i18n, t } = useTranslation();

  const languageMap = {
    tj: 1,
    ru: 2,
    en: 3,
  };

  const getLanguageCode = (lang) => languageMap[lang] || 2;

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    axios
      .get(`${API_BASE_URL}/api/texts?lang=${langCode}`, {
        headers: {
          accept: "text/plain",
          "api-version": "1.0",
        },
      })
      .then((response) => {
        setTexts(response.data.enttities);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [i18n.language]);

  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  return (
    <div className="container mt-5 mb-3">
      <div className="row mb-4">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="row g-0 align-items-center">
              <div data-aos="fade-right" className="col-lg-8 col-md-7">
                <div className="cart text-left  p-4 h-100 d-flex align-items-center">
                  <span className="quote-text">❝ {t("projectPr")} ❞</span>
                </div>
              </div>
              <div
                data-aos="fade-left"
                className="col-lg-4 col-md-5 d-flex flex-column align-items-center justify-content-center p-4"
              >
                <img
                  src={logo}
                  alt="Logo"
                  className="img-fluid logo-img mb-3"
                />
                <p className="president-title text-center">
                  <strong>{t("PresidentName")}</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="row g-0">
              <div data-aos="fade-up" className="col-lg-7 col-md-12">
                <div className="p-4">
                  <h2 className="card-title">{t("titleProject")}</h2>
                  <p style={{ color: "black" }} className="card-text">
                    {t("DescriptionProject")}
                  </p>
                </div>
              </div>
              <div data-aos="fade-up" className="col-lg-5 col-md-12">
                <div className="p-4">
                  {texts.length > 0 &&
                    texts.map((text, index) => (
                      <div key={index}>
                        <p className="mb-0">{text.text}</p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuotePrezident;
